// Route guard. Wraps the protected layout — if there's no partner session,
// kick to /signin and remember where the user was trying to go.

import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../lib/auth";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useAuth();
  const loc = useLocation();

  if (isLoading) {
    return <div className="app-loading"><span className="spinner" /> Loading…</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace state={{ from: loc.pathname + loc.search }} />;
  }
  return <>{children}</>;
}
